import React from 'react';
import { useResponsiveSizes } from '../../../../hooks/use-responsive-sizes';

interface ConfigFieldProps {
  keyName: string;
  value: any;
  getFieldLabel: (key: string) => string;
  formatValue: (value: any) => React.ReactNode;
  background?: string;
}

export const ConfigField: React.FC<ConfigFieldProps> = ({
  keyName,
  value,
  getFieldLabel,
  formatValue,
  background = 'white'
}) => {
  const { fontSize, spacing } = useResponsiveSizes();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: `${spacing.xs}px ${spacing.sm}px`,
        background,
        borderRadius: 6,
        fontSize: fontSize.sm
      }}
    >
      <span style={{ color: '#64748b', fontWeight: 500 }}>{getFieldLabel(keyName)}</span>
      <span style={{ color: '#0f172a', fontWeight: 600, textAlign: 'right' }}>{formatValue(value)}</span>
    </div>
  );
};
